import BenefitItem from "components/benefit-item";
import localStyles from "./register-admin-success.module.css";
import styles from "styles/onboarding.module.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import RegisterPresentation from "components/register/register-presentation";
import useIsMobile from "hooks/detect-mobile-screen";

const RegisterAdminSuccess = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile(980);
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/dashboard");
  };

  const benefits = [
    {
      title: t("onboarding.admin.success.benefits.title-1"),
      description: t("onboarding.admin.success.benefits.description-1"),
    },
    {
      title: t("onboarding.admin.success.benefits.title-2"),
      description: t("onboarding.admin.success.benefits.description-2"),
    },
    {
      title: t("onboarding.admin.success.benefits.title-3"),
      description: t("onboarding.admin.success.benefits.description-3"),
    },
    {
      title: t("onboarding.admin.success.benefits.title-4"),
      description: t("onboarding.admin.success.benefits.description-4"),
    },
  ];

  return (
    <div className={styles["register-container"]}>
      <section className={styles["register-content"]}>
        <div className={styles["content-header"]}>
          <div className="company-logo">
            <img src="logo.png" width="26" height="24" alt="" />
            <h1 className="title-2-variant">Kompa</h1>
          </div>
        </div>
        <div className={styles["content-actions"]}>
          <article className={localStyles.register}>
            <header className={styles["role-header"]}>
              <h2 className="title-1-variant">
                {t("onboarding.admin.success.title")}
              </h2>
              <p className="subtitle-1-variant">
                {t("onboarding.admin.success.description")}
              </p>
            </header>
            <div className={localStyles["benefits-list"]}>
              {benefits.map((benefit) => (
                <BenefitItem benefit={benefit} />
              ))}
            </div>
            <button
              data-testid="continue-button"
              className="btn btn--primary"
              onClick={handleRedirect}
            >
              {t("onboarding.admin.success.cta")}
            </button>
          </article>
        </div>
      </section>
      {!isMobile && <RegisterPresentation />}
    </div>
  );
};

export default RegisterAdminSuccess;
